import { Api } from "../api";

export const fetchCustomerPayments = async (from,to,page) => {
    try {
        const response = await Api.get("/customer-payments", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            params:{
                from,
                to,
                perPage:25,
                page
            }
        });

        const customer = {
            customer: response.data?.data?.[0]?.customer || [],
            customer_payments: response.data?.data || [],
            paginate: response.data || {},
        }; 
        return customer; 

    } catch (error) {
        
        if (error.response.status == 401) {
            localStorage.removeItem("token")
            window.location.href = "/"
        }
        console.error("Error fetching sales data:", error);
        return []; // Return an empty array in case of an error
    }
};
